import React from 'react'
import TokenBox from './TokenBox'
import { buyTokenStyle as styles } from './token.tailwind'
import tokensData from './token.data'

const BuyToken = () => {
  return (
    <section className={styles.component_wrapper}>
      <h1 className='landing_page_sub_heading'>
        SUPPORT THE TEAM.<br />BE PART OF THE GAME.
      </h1>

      {/* Tokens */}
      <div className={styles.token_card_wrpr}>
        {/* Tokens-Data */}
        {tokensData.map((token, index) => (
          <TokenBox key={index} token={token} />
        ))}
      </div>
    </section>
  )
}

export default BuyToken